export default __webpack_public_path__ + "static/media/dropdown-selecte-ic.f4a0c312.svg";